import React, { useRef, useState } from "react";

export default function DreamWebsiteActivity() {
  const [bgColor, setBgColor] = useState("#fce4ec"); // state for background color
  const fileInput = useRef(null);
  const imageBox = useRef(null);
  const funButton = useRef(null);

  const handleImageClick = () => fileInput.current.click();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function (event) {
        imageBox.current.style.backgroundImage = `url(${event.target.result})`;
        imageBox.current.textContent = "";
      };
      reader.readAsDataURL(file);
    }
  };

  const handleColorChange = (color) => setBgColor(color); // update state

  const handleButtonTextChange = () => {
    const newText = prompt("Change button text:", funButton.current.textContent);
    if (newText) funButton.current.textContent = newText;
  };

  const changeButtonStyle = (style) => {
    if (!funButton.current) return;

    if (style === "style1") {
      funButton.current.style.borderRadius = "30px";
      funButton.current.style.boxShadow = "none";
      funButton.current.style.border = "none";
      funButton.current.style.backgroundColor = "#ba68c8";
      funButton.current.style.color = "white";
    } else if (style === "style2") {
      funButton.current.style.borderRadius = "12px";
      funButton.current.style.boxShadow = "4px 4px 10px rgba(0,0,0,0.3)";
      funButton.current.style.border = "none";
      funButton.current.style.backgroundColor = "#ff8a65";
      funButton.current.style.color = "white";
    } else if (style === "style3") {
      funButton.current.style.borderRadius = "5px";
      funButton.current.style.boxShadow = "none";
      funButton.current.style.border = "3px solid #333";
      funButton.current.style.backgroundColor = "#fff";
      funButton.current.style.color = "#333";
    }
  };

  const colorPalette = ["#fce4ec", "#e1f5fe", "#f1f8e9", "#fff3e0", "#ede7f6"];
  const buttonStyles = [
    { label: "Rounded 💜", value: "style1" },
    { label: "Shadow 🌟", value: "style2" },
    { label: "Outline 🎀", value: "style3" },
  ];

  return (
    <div
      style={{
        fontFamily: "Comic Sans MS, cursive",
        textAlign: "center",
        backgroundColor: bgColor, // apply state here
        padding: 20,
        minHeight: "100vh",
      }}
    >
      <h1 contentEditable style={{ fontSize: "2.5em", color: "#4a148c", cursor: "pointer" }}>
        ✨ My Pets Website ✨
      </h1>

      <div
        ref={imageBox}
        onClick={handleImageClick}
        style={{
          width: 300,
          height: 200,
          border: "3px dashed #9c27b0",
          margin: "20px auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#9c27b0",
          cursor: "pointer",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        Click to add picture
      </div>
      <input
        type="file"
        ref={fileInput}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      <button
        ref={funButton}
        onClick={handleButtonTextChange}
        style={{
          padding: "15px 25px",
          fontSize: "1.2em",
          margin: 20,
          borderRadius: 12,
          border: "none",
          cursor: "pointer",
        }}
      >
        Click Me!
      </button>

      <h3>🎨 Choose Page Background Color:</h3>
      <div style={{ margin: "15px 0" }}>
        {colorPalette.map((color) => (
          <div
            key={color}
            onClick={() => handleColorChange(color)}
            style={{
              display: "inline-block",
              width: 40,
              height: 40,
              margin: 5,
              borderRadius: "50%",
              cursor: "pointer",
              border: "2px solid #333",
              backgroundColor: color,
            }}
          />
        ))}
      </div>

      <h3>🎨 Choose Button Style:</h3>
      <div style={{ margin: "15px 0" }}>
        {buttonStyles.map((b) => (
          <div
            key={b.value}
            onClick={() => changeButtonStyle(b.value)}
            style={{
              display: "inline-block",
              padding: "10px 15px",
              borderRadius: 8,
              fontSize: "0.9em",
              backgroundColor: "#eee",
              cursor: "pointer",
              margin: 5,
            }}
          >
            {b.label}
          </div>
        ))}
      </div>
    </div>
  );
}
